import navigation from '../navigation/rbmc.navigation';
import Breakpoints from 'breakpoints-js/dist/breakpoints.min';
import cartData from '../cart/rbmc.cart-data';

const cartTooltip = {
    pageBody:    undefined,
    cartIcon:    undefined,
    cart:        undefined,
    cartTimeout: undefined,
    mobile:      false,
    cartOpen:    false,
    bindCartTriggerEvents() {
        setTimeout(() => {
            cartTooltip.positionTooltipArrow(
                    cartTooltip.cart,
                    cartTooltip.cartIcon
            );

            $(window).on('resize', () => {
                cartTooltip.positionTooltipArrow(
                        cartTooltip.cart,
                        cartTooltip.cartIcon
                );
            });
        }, 1000);

        // Chrome error: Unable to preventDefault inside passive event listener due to target being treated as passive.
        // according: https://developers.google.com/web/updates/2017/01/scrolling-intervention
        // workaround check if passiveSupported and then set some flag to false, or
        // don't bind such handlers on document, window or body
        $('.page-header').on('touchstart click', '.page-header__cart-trigger', (evt) => {
            if (evt.type == 'touchstart') {
                evt.preventDefault();
                evt.stopPropagation();
                if (cartTooltip.cartOpen) {
                    cartTooltip.closeCart(cartTooltip.cartTimeout);
                    cartTooltip.cartOpen = false;
                } else {
                    clearTimeout(cartTooltip.cartTimeout);
                    cartData.refreshCartTooltip(() => {
                        cartTooltip.openCartOverlay();
                        cartTooltip.cartTimeout = setTimeout(cartTooltip.closeCart, 5000);
                    });
                }
            }
            if (evt.type == 'click') {
                // click event used in the future for tracking
            }
        });

        cartTooltip.pageBody.on('mouseenter', '.page-header__cart-trigger', () => {
            clearTimeout(cartTooltip.cartTimeout);
            cartData.refreshCartTooltip(cartTooltip.openCartOverlay);
        }).on('mouseleave', '.page-header__cart-trigger', () => {
            clearTimeout(cartTooltip.cartTimeout);
            cartTooltip.cartTimeout = setTimeout(cartTooltip.closeCart, 1000);
        });

        $(document).on('click', (e) => {
            if (cartTooltip.cartOpen) {
                if (!$(e.target).closest('#cart-tooltip').length &&
                        !$(e.target).closest('.page-header__cart-trigger').length) {
                    cartTooltip.closeCart(cartTooltip.cartTimeout);
                    cartTooltip.cartOpen = false;
                }
            }
        }).on('mouseenter', '#cart-tooltip', () => {
            clearTimeout(cartTooltip.cartTimeout);
        }).on('mouseleave', '#cart-tooltip', () => {
            cartTooltip.cartTimeout = setTimeout(cartTooltip.closeCart, 1000);
        });
    },

    closeCart(cartTimeout) {
        clearTimeout(cartTimeout);
        cartTooltip.cartOpen = false;
        cartTooltip.cart.addClass('d-none');
        // navigation.setGreyout(false);
    },

    positionTooltipArrow($element, $parent) {
        if ($parent && $parent.offset()) {
            $element.find('[class*=custom-tooltip__arrow]').css({
                right: $parent.offset().right + $parent.width() / 5
            });
        }
    },

    openCartOverlay() {
        cartTooltip.cartOpen = true;
        cartTooltip.cart.removeClass('d-none');
        // navigation.setGreyout(true);
    },

    init() {
        cartTooltip.pageBody = $('body');
        cartTooltip.cartIcon = cartTooltip.pageBody.find('.page-header__cart-trigger');
        cartTooltip.cart     = cartTooltip.pageBody.find('#cart-tooltip');
        if (cartTooltip.cartIcon.length) {
            Breakpoints.on('mobile', {
                enter: () => {
                    cartTooltip.mobile = true;
                },

                leave: () => {
                    cartTooltip.mobile = false;
                }
            });
            cartTooltip.bindCartTriggerEvents();
        }

    }
};

$(() => {
    cartTooltip.init();
});

export default cartTooltip;
